<template>
	<section class="spectrum-data-page">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option v-for="item in projects" :label="item.name" :value="item.projectId"
							:key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称">
					<el-select v-model="filters.mn" filterable>
						<el-option v-for="item in devices" :label="item.name" :value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码" v-if="type == 0">
					<el-select v-model="filters.mn" filterable>
						<el-option v-for="item in devices" :label="item.mnCode" :value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker v-model="filters.time" type="datetimerange" :picker-options="pickerOptions"
						unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<my-button @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-col :span="24" class="spectrum-data-content" v-loading="listLoading">
			<div class="spectrum-chart-head">
				<div>
					<span class="spectrum-title">历史频谱数据</span>
					<span class="spectrum-subtitle">{{ currentPointName }} {{ selectedRow.time || "" }}</span>
				</div>
				<span class="spectrum-subtitle">单位：dB</span>
			</div>
			<div id="chartLine" :style="{ height: chartHeight + 'px' }"></div>
		</el-col>
	</section>
</template>

<script>
import * as echarts from "echarts";
import { getProjects, getDevicesByProjectId, getFactorNoise ,getHistorySpectrum} from '../../api/api';
import {formatDate} from '../../../static/fun.js';

import myButton from '../../components/myButton/index.vue'

export default {
	props: {
		collapsed: {
			type: Boolean,
		},
	},
	components: { myButton },
	data() {
		return {
			pickerOptions: {
				shortcuts: [{
					text: '最近一小时',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三小时',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 3);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近六小时',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 6);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近半天',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 12);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			filters: {
				projectId: "",
				mn: "",
				time: []
			},
			type: sessionStorage.getItem("type"),
			projects: [],
			devices: [],
			dataList: [],
			selectedRow: {},
			chartTimer: null,
			resizeHandler: null,
			listLoading: false,
			firstFlag: true,
			formHeight: 0,
			hourLimit: 12,
			choosemn: "",
			charts: null,
			deviceMap: new Map(),
			factorMap: new Map(),
		}
	},
	computed: {
		factorEntries() {
			return Array.from(this.factorMap).map(item => {
				return {
					name: item[0],
					code: item[1]
				}
			});
		},
		frequencyList() {
			return Array.from(this.factorMap.keys());
		},
		currentPointName() {
			var device = this.deviceMap.get(this.choosemn);
			return device ? device.name : "";
		},
		chartHeight() {
			return Math.max(360, this.formHeight - 20);
		}
	},
	watch: {
		collapsed() {
			this.resizeChart();
		}
	},
	methods: {
		clickBtn(type) {
			if (type == "query") {
				this.getDataList();
			} else if (type == "export") {
				this.exportToExcel();
			}
		},
		//查询项目信息
		getProjects() {
			this.listLoading = true;
			getProjects().then((res) => {
				this.projects = res.data.data;
				this.listLoading = false;
				if (this.projects.length > 0) {
					this.filters.projectId = this.projects[0].projectId;
					this.getDevices();
				}
			}).catch(() => {
				this.listLoading = false;
			});
		},
		//获取设备列表
		getDevices() {
			let para = {
				projectId: this.filters.projectId
			};
			getDevicesByProjectId(para).then((res) => {
				this.devices = res.data.data;
				var flag = false;
				if (this.filters.mn != "") {
					this.devices.forEach(item => {
						if (item.mnCode == this.filters.mn) {
							flag = true;
						}
						this.deviceMap.set(item.mnCode, item)
					});
				}
				if (!flag && this.devices.length > 0) {
					this.filters.mn = this.devices[0].mnCode;
				}
				if (this.firstFlag) {
					this.firstFlag = false;
					this.getDataList();
				}
			}).catch(() => {
				this.listLoading = false;
			});
		},
		getDataList() {
			if (this.filters.mn == "") {
				this.$message({
					message: "未选择设备",
					type: 'warning'
				});
				return;
			}
			if (this.factorEntries.length == 0) {
				this.$message({
					message: "暂无频谱因子，无法展示",
					type: 'warning'
				});
				return;
			}
			var starttime='';
			var endtime='';
			if (this.filters.time != null && this.filters.time.length > 0) {
				starttime=formatDate(this.filters.time[0]);
				endtime=formatDate(this.filters.time[1]);
				var d1 = new Date(this.filters.time[0]);
				var d2 = new Date(this.filters.time[1]);
				var hours = parseInt(d2 - d1) / 1000 / 3600;
				if (hours > this.hourLimit) {
					this.$message({
						message: "选择时间范围超过" + this.hourLimit + "小时",
						type: 'warn'
					})
					return;
				}
			}
			this.listLoading = true;
			let para = {
				mn: this.filters.mn,
				startTime: starttime,
				endTime: endtime
			};

			getHistorySpectrum(para).then((res) => {
				this.listLoading = false;
				this.choosemn = this.filters.mn;
				this.dataList =  res.data.data;
				this.selectedRow = this.dataList[0] || {};
				this.startDynamicChart(this.dataList);
			}).catch(() => {
				this.listLoading = false;
			});
		},
		startDynamicChart(dataArray) {
			this.clearChartTimer();
			this.initChart();
			if (!dataArray || dataArray.length == 0) {
				return;
			}
			var index = 0;
			this.chartTimer = window.setInterval(() => {
				this.selectedRow = dataArray[index];
				this.initChart();
				index++;
				if (index >= dataArray.length) {
					this.clearChartTimer();
				}
			}, 500);
		},
		clearChartTimer() {
			if (this.chartTimer != null) {
				window.clearInterval(this.chartTimer);
				this.chartTimer = null;
			}
		},
		initChart() {
			var dom = document.getElementById("chartLine");
			if (!dom) {
				return;
			}
			if (this.charts == null) {
				this.charts = echarts.init(dom);
			}
			this.charts.setOption(this.getChartOption());
		},
		getChartOption() {
			var barValues = this.factorEntries.map(factor => {
				var value = this.selectedRow[factor.code];
				return value == null ? "-" : value;
			});
			return {
				animationDurationUpdate: 200,
				color: ['#59a869'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter: function (params) {
						var item = params[0];
						return item.name + '<br/>噪声值：' + item.value + ' dB';
					}
				},
				grid: {
					top: 60,
					left: 55,
					right: 55,
					bottom: 55
				},
				xAxis: {
					type: 'category',
					data: this.frequencyList,
					name: '频率',
					axisLabel: {
						interval: 0,
						rotate: 45
					}
				},
				yAxis: {
					type: 'value',
					name: '噪声值(dB)',
				},
				series: {
					type: 'bar',
					data: barValues,
					barMaxWidth: 26,
					label: {
						normal: {
							show: true,
							position: 'top',
							textStyle: {
								color: '#000'
							}
						}
					}
				}
			}
		},
		exportToExcel() {
			if (this.dataList.length == 0) {
				this.$message({
					message: "暂无可导出的频谱数据",
					type: 'warning'
				});
				return;
			}
			if (this.factorEntries.length == 0) {
				this.$message({
					message: "暂无频谱因子，无法导出",
					type: 'warning'
				});
				return;
			}
			var tHeader = ["采集时间"].concat(this.frequencyList);
			var rows = this.dataList.map(item => {
				var row = [item.time];
				this.factorEntries.forEach(factor => {
					row.push(item[factor.code]);
				});
				return row;
			});
			var data = [rows];
			var sheetName = ['Sheet1'];
			require.ensure([], () => {
				const { export_json_to_excel } = require('vendor/Export2Excel');
				export_json_to_excel(tHeader, data, '历史频谱数据', sheetName);
			});
		},
		getFactorNoise() {
			return getFactorNoise({}).then((res) => {
				var factor = res.data.data;
				var factorMap = new Map();
				for (let i = 0; i < factor.length; i++) {
					factorMap.set(factor[i].name, factor[i].code);
				}
				if (factorMap.size > 0) {
					this.factorMap = factorMap;
				}
			}).catch(() => {
				this.factorMap = new Map();
			});
		},
		SetHeight() {
			var content = document.getElementsByClassName('content-container')[0];
			var title = document.getElementsByClassName('tags-view-wrapper')[0];
			var toolbar = document.getElementsByClassName('toolbar')[0];
			if (!content || !title || !toolbar) {
				this.formHeight = 420;
				return;
			}
			this.formHeight = content.clientHeight - title.clientHeight - toolbar.clientHeight - 100;
			this.resizeChart();
		},
		setTime() {
			var end = new Date();
			var start = new Date();
			start.setTime(start.setHours(start.getHours()-1));
			this.filters.time= [formatDate(start), formatDate(end)];
		},
		resizeChart() {
			this.$nextTick(() => {
				if (this.charts != null) {
					this.charts.resize();
				}
			});
		}
	},
	mounted() {
		this.setTime();
		this.$nextTick(() => {
			this.SetHeight();
		});
		this.resizeHandler = () => {
			this.SetHeight();
		};
		window.addEventListener('resize', this.resizeHandler);
		this.getFactorNoise().then(() => {
			this.getProjects();
		});
	},
	destroyed() {
		this.clearChartTimer();
		if (this.resizeHandler != null) {
			window.removeEventListener('resize', this.resizeHandler);
			this.resizeHandler = null;
		}
		if (this.charts != null) {
			this.charts.dispose();
			this.charts = null;
		}
	}
}
</script>

<style>
.spectrum-data-page .cell {
	text-align: center;
}

.spectrum-data-page .el-form {
	overflow: hidden;
}

.spectrum-data-content {
	padding: 10px;
	background: #fff;
}

.spectrum-chart-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 32px;
}

.spectrum-title {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-right: 12px;
}

.spectrum-subtitle {
	font-size: 12px;
	color: #909399;
}
</style>




// WEBPACK FOOTER //
// SpectrumData.vue?745f6f8a